// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__EBked","title":"ClientReferral_title__2k7Fv","itemText":"ClientReferral_itemText__2o9uS"};